import { useEffect, useState } from 'preact/hooks'

import { getDomainsFromAPI } from 'services/wp-api/domains-api'
import { createRegistryUrl } from 'utils/urls'
import { REGISTRY_URL } from 'apps-calculators/config'

export const useRegistryUrl = (params?: Record<string, string>): string => {
  const [registryUrl, setRegistryUrl] = useState(REGISTRY_URL)

  useEffect(() => {
    const fetchRegistryUrl = async () => {
      try {
        const { registry } = await getDomainsFromAPI()
        if (registry) setRegistryUrl(registry)
      } catch (error) {
        console.error('Error fetching registry URL:', error)
      }
    }
    fetchRegistryUrl()
  }, [])

  return createRegistryUrl(registryUrl, params)
}
